import React from 'react';
import { ButtonProps } from 'antd/es/button';
import { Button } from 'antd';

type Props = {
  onFocus?: ButtonProps['onFocus'];
} & ButtonProps;

const ButtonWithoutFocus: React.FC<Props> = ({ onFocus, ...rest }: Props) => {
  return (
    <Button
      onFocus={e => {
        if (onFocus) {
          onFocus(e);
        } else {
          e.target.blur();
        }
      }}
      {...rest}
    />
  );
};

export default ButtonWithoutFocus;
